/**
 * Paths que NÃO exigem autenticação. Usado por:
 *   - Axios interceptor (não dispara `auth:unauthorized` 401 vindo de cascata)
 *   - AuthGuard (não navega pra /login se já está numa rota pública)
 *   - useUser (não chama getProfile se path for público — evita 401 desnecessário)
 *
 * Bug que motivou: fornecedor abria /cot/{token} num browser que tinha auth_token
 * STALE no localStorage (de tentativa anterior, sessão expirada, etc). O
 * SignalRProvider chamava useUser → getProfile → 401 → axios interceptor
 * disparava `auth:unauthorized` → AuthGuard navegava pra /login. Fornecedor
 * ficava preso no login sem nunca ver o form da cotação.
 */
export const PUBLIC_PATH_PREFIXES = ['/login', '/cot/'];

export const isPublicPath = (pathname: string): boolean =>
  PUBLIC_PATH_PREFIXES.some((p) => pathname === p || pathname.startsWith(p));
